export const DAILY_OVERTIME_DASHBOARD_PATH = '/reports/overtime-daily';

export const DATA_TABLE_PAGE_SIZE = 10;

export const LINE_CHART_MARGIN = { top: 16, right: 24, bottom: 44, left: 50 };
export const LINE_CHART_HEIGHT = 300;
export const LINE_CHART_DOT_RADIUS = 4;
export const LINE_CHART_DOT_HOVER_RADIUS = 6;
export const LINE_CHART_STROKE_WIDTH = 2;

const MONTH_ABBREVIATIONS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

export function formatDateLabel(date: Date): string {
  return `${MONTH_ABBREVIATIONS[date.getMonth()]} ${date.getDate()}`;
}

export const DONUT_MIN_SIZE = 160;
export const DONUT_INNER_RATIO = 0.6;
export const DONUT_FILL_RATIO = 0.85;

export const HORIZONTAL_BAR_RIGHT_MARGIN = 80;

export const TEAM_MEMBER_TYPE_COLORS: Record<string, string> = {
  'Full Time': '#2D2B55',
  'Part Time': '#4A4580',
  Casual: '#7E78B8',
  Flex: '#D4D2E8',
};

const EMPLOYMENT_STATUS_LABELS: Record<string, string> = {
  full_time: 'Full Time',
  part_time: 'Part Time',
  casual: 'Casual',
  flex: 'Flex',
  not_sure: 'Not Sure',
  terminated: 'Terminated',
};

export function formatEmploymentStatusLabel(status: string): string {
  return EMPLOYMENT_STATUS_LABELS[status] ?? status;
}
